import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { RECONCILE_STATUS } from '_constants/transactions';
import { hexToRGBA } from '_helpers/theme';

import Select from 'components/atomic/controls/Select';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .base-select-container {
    .base-select__control {
      .base-select__value-container {
        .base-select__input-container {
          font-weight: 600;
        }

        .base-select__single-value {
          font-weight: 600;
        }

        .base-select__placeholder {
          font-weight: 600;
        }
      }
    }

    .base-select__menu {
      .base-select__menu-list {
        .base-select__option {
          font-weight: 600;
          color: ${theme.colors.gray.primary};

          &.base-select__option--is-selected {
            background-color: ${theme.colors.indigo.primary};
          }
        }
      }
    }
  }
`;

const ReconcileFilter = ({ name, value, onSelect }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onSelect({ [name]: value });
  };

  return (
    <StyledContainer>
      <Select
        small
        textColor={theme.colors.gray.secondary}
        backgroundColor={hexToRGBA(theme.colors.gray.secondary, 0.08)}
        name={name}
        value={value}
        options={[
          { title: 'All', value: '' },
          { title: 'Reconciled', value: RECONCILE_STATUS.reconciled },
          { title: 'Unreconciled', value: RECONCILE_STATUS.unreconciled },
        ]}
        onChange={handleChange}
      />
    </StyledContainer>
  );
};

ReconcileFilter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func,
};

export default ReconcileFilter;
